var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgListViewActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "list-ul",
    d: "M33.333,64a1.333,1.333,0,1,0,1.333,1.333A1.333,1.333,0,0,0,33.333,64ZM38,64.667A.667.667,0,1,0,38,66H51.333a.667.667,0,1,0,0-1.333Zm0,6.667a.667.667,0,1,0,0,1.333H51.333a.667.667,0,0,0,0-1.333ZM38,78a.667.667,0,1,0,0,1.333H51.333a.667.667,0,0,0,0-1.333Zm-3.333-6a1.333,1.333,0,1,0-1.333,1.333A1.333,1.333,0,0,0,34.667,72Zm-1.333,5.333a1.333,1.333,0,1,0,1.333,1.333A1.333,1.333,0,0,0,33.333,77.333Z",
    transform: "translate(-32 -64)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListViewActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list-view-active.9928eee204f8b6320d459929fd792662.svg";